module.exports = __webpack_public_path__ + "img/button_anotovanie.83ab491d.svg";